import { ClassificationRunSchema } from "@redotech/redo-conversion-settings-common/landed-cost-settings";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getLcgClassifyStatus = {
  name: "getLcgClassifyStatus" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    isClassifying: z.boolean(),
    workflowStartTime: z.date().nullable(),
    classificationRun: ClassificationRunSchema.nullable(),
  }),
};
